import React from 'react';
import { motion } from 'framer-motion';
export function Mechanism() {
  return <section className="py-20 md:py-32 px-5 bg-[#5C1A2B] text-[#FAF5EE] text-center relative overflow-hidden" data-id="element-115">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at center, #FAF5EE 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-116"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-117">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-4xl md:text-6xl mb-6 text-[#FAF5EE] leading-tight" data-id="element-118">
          El Filtro de Sinceridad Brutal
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-base md:text-lg font-light mb-14 leading-relaxed text-[#E0D5C1]" data-id="element-119">
          Un balde de agua fría en 20 páginas. No te enseña "cómo recuperarlo" —
          te da las herramientas para extirparlo de tu sistema.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-120">
          <blockquote className="font-serif text-2xl md:text-4xl lg:text-5xl italic text-[#C86B5E] leading-tight" data-id="element-121">
            "No es lectura romántica.
            <br data-id="element-122" />
            Es cirugía de emergencia
            <br data-id="element-123" />
            para tu amor propio."
          </blockquote>
        </motion.div>
      </div>
    </section>;
}